import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";
import ProductCard from "../components/ProductCard";
import { Button } from "../components/ui/button";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const { user, wishlist, setAuthModalOpen } = useApp();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }
    api.get("/wishlist").then(({ data }) => {
      setProducts(data);
      setLoading(false);
    });
  }, [user, wishlist]);

  if (!user) {
    return (
      <div className="max-w-xl mx-auto px-4 py-24 text-center">
        <Heart size={56} className="mx-auto text-slate-300 mb-4" />
        <h1 className="font-display text-2xl font-bold mb-3">Your Wishlist</h1>
        <p className="text-slate-500 mb-6">Login to view and save your favourite styles.</p>
        <Button onClick={() => setAuthModalOpen(true)} className="bg-[#E63946] hover:bg-[#d12836]">Login</Button>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="font-display text-2xl sm:text-3xl font-bold mb-8">My Wishlist ({products.length})</h1>
      {loading ? (
        <p className="text-slate-400">Loading...</p>
      ) : products.length === 0 ? (
        <div className="text-center py-20">
          <Heart size={56} className="mx-auto text-slate-300 mb-4" />
          <p className="text-slate-500 mb-6">No favourites yet.</p>
          <Link to="/shop"><Button className="bg-[#E63946] hover:bg-[#d12836]">Explore Products</Button></Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-testid="wishlist-grid">
          {products.map((p, i) => (
            <ProductCard key={p.id} product={p} index={i} />
          ))}
        </div>
      )}
    </div>
  );
}
